var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "question-wrap",
      class: [
        { isLine: _vm.value.type === _vm.QTypes.LINE },
        { isRemark: _vm.value.type === _vm.QTypes.REMARK },
      ],
    },
    [
      _vm.value.ext && _vm.value.ext.edit
        ? _c(
            "div",
            {
              staticClass: "sort",
              staticStyle: {
                width: "100%",
                "text-align": "center",
                cursor: "move",
                position: "absolute",
              },
            },
            [
              _c("img", {
                staticStyle: {
                  cursor: "move",
                  dragable: "false",
                  display: "inline-block",
                },
                attrs: {
                  width: "40",
                  src: "http://cnstatic01.e.vhall.com/static/images/signup-form/drop.png?v=o78iE3bYNdTd377uDRu6Jw%3D%3D",
                  alt: "",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "question-content",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.questionClick.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "index",
              class: [
                { isLine: _vm.value.type === _vm.QTypes.LINE },
                { isRemark: _vm.value.type === _vm.QTypes.REMARK },
              ],
            },
            [
              _vm.value.required === "Y"
                ? _c(
                    "span",
                    {
                      staticClass: "require-icon",
                      staticStyle: { color: "red" },
                    },
                    [_vm._v("*")]
                  )
                : _vm._e(),
              _vm._v(_vm._s(_vm.getIndex) + "."),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "q-edit display" },
            [
              _vm.value.ext && _vm.value.ext.edit
                ? _c("div", { staticClass: "q-subject" }, [
                    _vm.value.type === _vm.QTypes.RADIO &&
                    _vm.value.style == "radio"
                      ? _c("span", [_vm._v("单选")])
                      : _vm.value.type === _vm.QTypes.CHECKBOX
                      ? _c("span", [_vm._v("多选")])
                      : _vm.value.type === _vm.QTypes.SELECT
                      ? _c("span", [_vm._v("下拉题")])
                      : _vm.value.type === _vm.QTypes.AREA
                      ? _c("span", [_vm._v("地域")])
                      : _vm.value.type === _vm.QTypes.REMARK
                      ? _c("span", [_vm._v("小节")])
                      : _vm.value.style === _vm.QTypes.COMPANY
                      ? _c("span", [_vm._v("公司")])
                      : _vm.value.style === _vm.QTypes.POSTION
                      ? _c("span", [_vm._v("职务")])
                      : _vm.value.style === _vm.QTypes.NAME
                      ? _c("span", [_vm._v("姓名")])
                      : _vm.value.style === _vm.QTypes.SEX
                      ? _c("span", [_vm._v("性别")])
                      : _vm.value.style === _vm.QTypes.PHONE
                      ? _c("span", [_vm._v("手机")])
                      : _vm.value.style === _vm.QTypes.EMAIL
                      ? _c("span", [_vm._v("邮箱")])
                      : _vm.value.style === _vm.QTypes.BIRTHDAY
                      ? _c("span", [_vm._v("生日")])
                      : _vm.value.style === _vm.QTypes.INDUSTRY
                      ? _c("span", [_vm._v("行业")])
                      : _vm.value.style === _vm.QTypes.EDUCATION
                      ? _c("span", [_vm._v("教育水平")])
                      : _vm.value.type === _vm.QTypes.TEXT
                      ? _c("span", [_vm._v("问答")])
                      : _vm._e(),
                  ])
                : _c("div", { staticClass: "q-subject" }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.value.title) },
                    }),
                  ]),
              _vm._v(" "),
              _vm.value.type === _vm.QTypes.LINE
                ? _c("div", { staticClass: "line" })
                : _vm._e(),
              _vm._v(" "),
              _vm.showInputCom
                ? _c("com-input", {
                    staticClass: "q-subject",
                    class: { error: _vm.value.error },
                    attrs: { placeholder: "请输入题目", "max-length": 100 },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                      change: _vm.changeTitle,
                      focus: _vm.focusTitle,
                    },
                    model: {
                      value: _vm.value.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "title", $$v)
                      },
                      expression: "value.title",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    ["phone", "privacy"].includes(_vm.value.ext.type)
                      ? _vm.value.ext.type
                      : _vm.QComs[_vm.value.type],
                    {
                      ref: "content",
                      tag: "component",
                      attrs: {
                        isPreview: _vm.isPreview,
                        isReplay: _vm.isReplay,
                      },
                      model: {
                        value: _vm.value,
                        callback: function ($$v) {
                          _vm.value = $$v
                        },
                        expression: "value",
                      },
                    }
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.value.ext && _vm.value.ext.edit
            ? _c(
                "div",
                {
                  staticClass: "q-operate",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _vm.value.type === _vm.QTypes.MATRIX
                    ? _c(
                        "a",
                        {
                          staticClass: "add-row-item",
                          on: { click: _vm.addRowItem },
                        },
                        [_vm._v("添加行选项")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.value.type === _vm.QTypes.MATRIX
                    ? _c(
                        "a",
                        {
                          staticClass: "add-column-item",
                          on: { click: _vm.addColumnItem },
                        },
                        [_vm._v("添加列选项")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAddItem || _vm.value.type === _vm.QTypes.SELECT
                    ? _c(
                        "a",
                        {
                          staticClass: "add-select-item",
                          class: {
                            disabledAdd: _vm.value.detail.list.length >= 30,
                          },
                          on: { click: _vm.addItem },
                        },
                        [
                          _c("i", { staticClass: "vh-icon-plus" }),
                          _vm._v("添加选项"),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAddItem
                    ? _c("span", { staticClass: "line add-other-item" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAddItem
                    ? _c(
                        "a",
                        {
                          staticClass: "add-select-item add-other-item",
                          class: {
                            disabledAdd:
                              _vm.value.detail.list.length >= 30 ||
                              _vm.value.detail.list.some(function (i) {
                                return i.custom_opt == 1
                              }),
                          },
                          on: { click: _vm.addOtherItem },
                        },
                        [
                          _c("i", { staticClass: "vh-icon-plus" }),
                          _vm._v("添加其他"),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAddItem || _vm.value.type === _vm.QTypes.SELECT
                    ? _c("span", { staticClass: "addTip" }, [
                        _vm._v("最多支持添加30个"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "del",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.remove.apply(null, arguments)
                        },
                      },
                    },
                    [_c("i", { staticClass: "iconfont-v3 saasicon-trash" })]
                  ),
                  _vm._v(" "),
                  _vm.showRequire && _vm.value.ext && _vm.value.ext.edit
                    ? _c("span", { staticClass: "required-des" }, [
                        _vm._v("必填项"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showRequire && _vm.value.ext && _vm.value.ext.edit
                    ? _c("vh-switch", {
                        key: _vm.index,
                        staticClass: "switch",
                        attrs: {
                          "active-color": "#FB3A32",
                          "inactive-color": "#CECECE",
                          size: "mini",
                          width: 32,
                        },
                        model: {
                          value: _vm.verifiy,
                          callback: function ($$v) {
                            _vm.verifiy = $$v
                          },
                          expression: "verifiy",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }